var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 60.0001H0V0H60V60.0001Z",
    fill: "#75B043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4407 59.4364H0.563843V0.55957H59.4407V59.4364Z",
    fill: "#00333A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 31.1143L5.3208 34.6952L1.73102 38.2762V31.1143Z",
    fill: "#75B043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12274 35.8888V33.5015L5.3208 34.6951L4.12274 35.8888Z",
    fill: "#008A4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73096 35.8888V33.5015L2.92902 34.6951L1.73096 35.8888Z",
    fill: "#008A4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92877 34.6949V32.3076L4.12243 33.5013L2.92877 34.6949Z",
    fill: "#008A4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 33.5016V31.1143L2.92908 32.3079L1.73102 33.5016Z",
    fill: "#008A4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92877 37.0831V34.6958L4.12243 35.8895L2.92877 37.0831Z",
    fill: "#008A4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73096 38.276V35.8887L2.92902 37.0823L1.73096 38.276Z",
    fill: "#008A4B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2975 38.2762L7.71216 34.6952L11.2975 31.1143V38.2762Z",
    fill: "#75B043"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9057 33.5015V35.8888L7.71204 34.6951L8.9057 33.5015Z",
    fill: "#008A4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2972 33.5015V35.8888L10.1036 34.6951L11.2972 33.5015Z",
    fill: "#008A4B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1038 34.6958V37.0831L8.90576 35.8895L10.1038 34.6958Z",
    fill: "#008A4B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2972 35.8887V38.276L10.1036 37.0823L11.2972 35.8887Z",
    fill: "#008A4B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1038 32.3076V34.6949L8.90576 33.5013L10.1038 32.3076Z",
    fill: "#008A4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2972 31.1143V33.5016L10.1036 32.3079L11.2972 31.1143Z",
    fill: "#008A4B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 39.5659L5.3208 43.1469L1.73102 46.7279V39.5659Z",
    fill: "#75B043"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12274 44.3414V41.9541L5.3208 43.1478L4.12274 44.3414Z",
    fill: "#008A4B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73096 44.3414V41.9541L2.92902 43.1478L1.73096 44.3414Z",
    fill: "#008A4B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92877 43.1481V40.7607L4.12243 41.9544L2.92877 43.1481Z",
    fill: "#008A4B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 41.9532V39.5659L2.92908 40.7596L1.73102 41.9532Z",
    fill: "#008A4B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92877 45.5343V43.147L4.12243 44.3406L2.92877 45.5343Z",
    fill: "#008A4B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73096 46.7286V44.3413L2.92902 45.535L1.73096 46.7286Z",
    fill: "#008A4B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2975 46.7279L7.71216 43.1469L11.2975 39.5659V46.7279Z",
    fill: "#75B043"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9057 41.9541V44.3414L7.71204 43.1478L8.9057 41.9541Z",
    fill: "#008A4B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2972 41.9541V44.3414L10.1036 43.1478L11.2972 41.9541Z",
    fill: "#008A4B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1038 43.147V45.5343L8.90576 44.3406L10.1038 43.147Z",
    fill: "#008A4B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2972 44.3413V46.7286L10.1036 45.535L11.2972 44.3413Z",
    fill: "#008A4B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1038 40.7607V43.1481L8.90576 41.9544L10.1038 40.7607Z",
    fill: "#008A4B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2972 39.5659V41.9532L10.1036 40.7596L11.2972 39.5659Z",
    fill: "#008A4B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.298 38.9723L7.01224 43.2536L11.298 47.5305H10.3025L6.51451 43.7513L6.20179 44.064L5.65121 44.6102H6.74797L7.28093 45.1432H5.11825L4.20648 46.055H8.19709L8.73006 46.5879H3.67353L2.72653 47.5305H1.73108L6.0168 43.2536L1.73108 38.9723L6.0168 34.6954L1.73108 30.4141H2.72653L6.51451 34.1976L6.80963 33.9025L7.32937 33.3828H6.34274L5.80978 32.8542H7.86234L8.7785 31.9381H4.89802L4.36506 31.4095H9.30707L10.3025 30.4141H11.298L7.01224 34.6954L11.298 38.9723ZM5.50586 36.1974H7.52759L6.51451 35.1887L5.50586 36.1974ZM4.3166 37.3866H8.71683L8.06054 36.7303H4.97289L4.3166 37.3866ZM3.00403 38.6992H10.0338L9.2542 37.9196H3.78364L3.00403 38.6992ZM7.57603 41.6988H5.46181L6.51892 42.7515L7.57603 41.6988ZM8.84898 40.4302H4.18886L4.92885 41.1702H8.109L8.84898 40.4302ZM9.38194 39.8973L10.047 39.2322H2.9908L3.6559 39.8973H9.38194Z",
    fill: "#008A4B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73108 13.1616L5.32086 16.7426L1.73108 20.328V13.1616Z",
    fill: "#75B043"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1228 17.9352V15.5479L5.32087 16.7415L4.1228 17.9352Z",
    fill: "#008A4B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 17.9352V15.5479L2.92908 16.7415L1.73102 17.9352Z",
    fill: "#008A4B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92883 16.7418V14.3545L4.12249 15.5481L2.92883 16.7418Z",
    fill: "#008A4B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73108 15.5489V13.1616L2.92914 14.3553L1.73108 15.5489Z",
    fill: "#008A4B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92883 19.1344V16.7427L4.12249 17.9363L2.92883 19.1344Z",
    fill: "#008A4B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 20.3278V17.936L2.92908 19.1341L1.73102 20.3278Z",
    fill: "#008A4B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2976 20.328L7.71222 16.7426L11.2976 13.1616V20.328Z",
    fill: "#75B043"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90576 15.5479V17.9352L7.7121 16.7415L8.90576 15.5479Z",
    fill: "#008A4B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 15.5479V17.9352L10.1036 16.7415L11.2973 15.5479Z",
    fill: "#008A4B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1039 16.7427V19.1344L8.90582 17.9363L10.1039 16.7427Z",
    fill: "#008A4B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 17.936V20.3278L10.1036 19.1341L11.2973 17.936Z",
    fill: "#008A4B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1039 14.3545V16.7418L8.90582 15.5481L10.1039 14.3545Z",
    fill: "#008A4B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 13.1616V15.5489L10.1036 14.3553L11.2973 13.1616Z",
    fill: "#008A4B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73108 21.6128L5.32086 25.1938L1.73108 28.7791V21.6128Z",
    fill: "#75B043"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1228 26.3883V24.001L5.32087 25.1946L4.1228 26.3883Z",
    fill: "#008A4B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 26.3883V24.001L2.92908 25.1946L1.73102 26.3883Z",
    fill: "#008A4B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92883 25.1954V22.8081L4.12249 24.0018L2.92883 25.1954Z",
    fill: "#008A4B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73108 24.0001V21.6128L2.92914 22.8064L1.73108 24.0001Z",
    fill: "#008A4B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92883 27.5861V25.1943L4.12249 26.388L2.92883 27.5861Z",
    fill: "#008A4B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 28.7794V26.3877L2.92908 27.5858L1.73102 28.7794Z",
    fill: "#008A4B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2976 28.7791L7.71222 25.1938L11.2976 21.6128V28.7791Z",
    fill: "#75B043"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90576 24.001V26.3883L7.7121 25.1946L8.90576 24.001Z",
    fill: "#008A4B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 24.001V26.3883L10.1036 25.1946L11.2973 24.001Z",
    fill: "#008A4B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1039 25.1943V27.5861L8.90582 26.388L10.1039 25.1943Z",
    fill: "#008A4B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 26.3877V28.7794L10.1036 27.5858L11.2973 26.3877Z",
    fill: "#008A4B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1039 22.8081V25.1954L8.90582 24.0018L10.1039 22.8081Z",
    fill: "#008A4B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 21.6128V24.0001L10.1036 22.8064L11.2973 21.6128Z",
    fill: "#008A4B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.298 21.024L7.0123 25.301L11.298 29.5823H10.3026L6.51457 25.7987L6.20185 26.1158L5.65127 26.662H6.74803L7.28099 27.1949H5.11831L4.20655 28.1067H8.19715L8.73012 28.6397H3.67359L2.72659 29.5823H1.73114L6.01686 25.301L1.73114 21.024L6.01686 16.7427L1.73114 12.4658H2.72659L6.51457 16.2494L6.80969 15.9543L7.32943 15.4345H6.3428L5.80984 14.9016H7.8624L8.77856 13.9898H4.89808L4.36512 13.4569H9.30713L10.3026 12.4658H11.298L7.0123 16.7427L11.298 21.024ZM5.50592 18.2535H7.52765L6.51457 17.2449L5.50592 18.2535ZM4.31666 19.4384H8.71689L8.06061 18.7821H4.97295L4.31666 19.4384ZM3.00409 20.751H10.0339L9.25426 19.9713H3.7837L3.00409 20.751ZM7.57609 23.7505H5.46187L6.51898 24.8076L7.57609 23.7505ZM8.84904 22.482H4.18892L4.92891 23.2176H8.10906L8.84904 22.482ZM9.382 21.9534L10.0471 21.2839H2.99086L3.65597 21.9534H9.382Z",
    fill: "#008A4B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 31.1143L52.2919 34.6952L48.7021 38.2762V31.1143Z",
    fill: "#75B043"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0939 35.8888V33.5015L52.292 34.6951L51.0939 35.8888Z",
    fill: "#008A4B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 35.8888V33.5015L49.9002 34.6951L48.7021 35.8888Z",
    fill: "#008A4B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 34.6949V32.3076L51.0936 33.5013L49.9 34.6949Z",
    fill: "#008A4B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 33.5016V31.1143L49.9001 32.3079L48.7021 33.5016Z",
    fill: "#008A4B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 37.0831V34.6958L51.0936 35.8895L49.9 37.0831Z",
    fill: "#008A4B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 38.276V35.8887L49.9002 37.0823L48.7021 38.276Z",
    fill: "#008A4B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2691 38.2762L54.6837 34.6952L58.2691 31.1143V38.2762Z",
    fill: "#75B043"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8774 33.5015V35.8888L54.6837 34.6951L55.8774 33.5015Z",
    fill: "#008A4B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2694 33.5015V35.8888L57.0757 34.6951L58.2694 33.5015Z",
    fill: "#008A4B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 34.6958V37.0831L55.877 35.8895L57.075 34.6958Z",
    fill: "#008A4B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2694 35.8887V38.276L57.0757 37.0823L58.2694 35.8887Z",
    fill: "#008A4B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 32.3076V34.6949L55.877 33.5013L57.075 32.3076Z",
    fill: "#008A4B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2694 31.1143V33.5016L57.0757 32.3079L58.2694 31.1143Z",
    fill: "#008A4B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 39.5659L52.2919 43.1469L48.7021 46.7279V39.5659Z",
    fill: "#75B043"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0939 44.3414V41.9541L52.292 43.1478L51.0939 44.3414Z",
    fill: "#008A4B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 44.3414V41.9541L49.9002 43.1478L48.7021 44.3414Z",
    fill: "#008A4B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 43.1481V40.7607L51.0936 41.9544L49.9 43.1481Z",
    fill: "#008A4B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 41.9532V39.5659L49.9001 40.7596L48.7021 41.9532Z",
    fill: "#008A4B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 45.5343V43.147L51.0936 44.3406L49.9 45.5343Z",
    fill: "#008A4B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 46.7286V44.3413L49.9002 45.535L48.7021 46.7286Z",
    fill: "#008A4B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2691 46.7279L54.6837 43.1469L58.2691 39.5659V46.7279Z",
    fill: "#75B043"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8774 41.9541V44.3414L54.6837 43.1478L55.8774 41.9541Z",
    fill: "#008A4B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2694 41.9541V44.3414L57.0757 43.1478L58.2694 41.9541Z",
    fill: "#008A4B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 43.147V45.5343L55.877 44.3406L57.075 43.147Z",
    fill: "#008A4B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2694 44.3413V46.7286L57.0757 45.535L58.2694 44.3413Z",
    fill: "#008A4B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 40.7607V43.1481L55.877 41.9544L57.075 40.7607Z",
    fill: "#008A4B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2694 39.5659V41.9532L57.0757 40.7596L58.2694 39.5659Z",
    fill: "#008A4B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2689 38.9723L53.9832 43.2536L58.2689 47.5305H57.2734L53.4855 43.7513L53.1727 44.064L52.6222 44.6102H53.7233L54.2519 45.1432H52.0892L51.1774 46.055H55.168L55.701 46.5879H50.6445L49.6975 47.5305H48.702L52.9877 43.2536L48.702 38.9723L52.9877 34.6954L48.702 30.4141H49.6975L53.4855 34.1976L53.7806 33.9025L54.3003 33.3828H53.3137L52.7807 32.8542H54.8333L55.7494 31.9381H51.8689L51.336 31.4095H56.2824L57.2734 30.4141H58.2689L53.9832 34.6954L58.2689 38.9723ZM52.4768 36.1974H54.4985L53.4855 35.1887L52.4768 36.1974ZM51.2875 37.3866H55.6878L55.0315 36.7303H51.9438L51.2875 37.3866ZM49.975 38.6992H57.0048L56.2251 37.9196H50.759L49.975 38.6992ZM54.5426 41.6988H52.4283L53.4855 42.7515L54.5426 41.6988ZM55.8155 40.4302H51.1554L51.8954 41.1702H55.0755L55.8155 40.4302ZM56.3485 39.8973L57.018 39.2322H49.9573L50.6269 39.8973H56.3485Z",
    fill: "#008A4B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48.702 13.1616L52.2918 16.7426L48.702 20.328V13.1616Z",
    fill: "#75B043"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0939 17.9352V15.5479L52.2919 16.7415L51.0939 17.9352Z",
    fill: "#008A4B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 17.9352V15.5479L49.9001 16.7415L48.7021 17.9352Z",
    fill: "#008A4B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8999 16.7418V14.3545L51.0936 15.5481L49.8999 16.7418Z",
    fill: "#008A4B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M48.702 15.5489V13.1616L49.9001 14.3553L48.702 15.5489Z",
    fill: "#008A4B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8999 19.1344V16.7427L51.0936 17.9363L49.8999 19.1344Z",
    fill: "#008A4B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 20.3278V17.936L49.9001 19.1341L48.7021 20.3278Z",
    fill: "#008A4B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M58.269 20.328L54.6837 16.7426L58.269 13.1616V20.328Z",
    fill: "#75B043"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8773 15.5479V17.9352L54.6837 16.7415L55.8773 15.5479Z",
    fill: "#008A4B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2693 15.5479V17.9352L57.0757 16.7415L58.2693 15.5479Z",
    fill: "#008A4B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 16.7427V19.1344L55.8769 17.9363L57.075 16.7427Z",
    fill: "#008A4B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2693 17.936V20.3278L57.0757 19.1341L58.2693 17.936Z",
    fill: "#008A4B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 14.3545V16.7418L55.8769 15.5481L57.075 14.3545Z",
    fill: "#008A4B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2693 13.1616V15.5489L57.0757 14.3553L58.2693 13.1616Z",
    fill: "#008A4B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M48.702 21.6128L52.2918 25.1938L48.702 28.7791V21.6128Z",
    fill: "#75B043"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0939 26.3883V24.001L52.2919 25.1946L51.0939 26.3883Z",
    fill: "#008A4B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 26.3883V24.001L49.9001 25.1946L48.7021 26.3883Z",
    fill: "#008A4B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8999 25.1954V22.8081L51.0936 24.0018L49.8999 25.1954Z",
    fill: "#008A4B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M48.702 24.0001V21.6128L49.9001 22.8064L48.702 24.0001Z",
    fill: "#008A4B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8999 27.5861V25.1943L51.0936 26.388L49.8999 27.5861Z",
    fill: "#008A4B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 28.7794V26.3877L49.9001 27.5858L48.7021 28.7794Z",
    fill: "#008A4B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M58.269 28.7791L54.6837 25.1938L58.269 21.6128V28.7791Z",
    fill: "#75B043"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8773 24.001V26.3883L54.6837 25.1946L55.8773 24.001Z",
    fill: "#008A4B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2693 24.001V26.3883L57.0757 25.1946L58.2693 24.001Z",
    fill: "#008A4B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 25.1943V27.5861L55.8769 26.388L57.075 25.1943Z",
    fill: "#008A4B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2693 26.3877V28.7794L57.0757 27.5858L58.2693 26.3877Z",
    fill: "#008A4B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M57.075 22.8081V25.1954L55.8769 24.0018L57.075 22.8081Z",
    fill: "#008A4B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2693 21.6128V24.0001L57.0757 22.8064L58.2693 21.6128Z",
    fill: "#008A4B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2688 21.024L53.9831 25.301L58.2688 29.5823H57.2734L53.4854 25.7987L53.1727 26.1158L52.6221 26.662H53.7233L54.2518 27.1949H52.0891L51.1774 28.1067H55.168L55.7009 28.6397H50.6444L49.6974 29.5823H48.702L52.9877 25.301L48.702 21.024L52.9877 16.7427L48.702 12.4658H49.6974L53.4854 16.2494L53.7805 15.9543L54.3003 15.4345H53.3136L52.7807 14.9016H54.8332L55.7494 13.9898H51.8689L51.3359 13.4569H56.2823L57.2734 12.4658H58.2688L53.9831 16.7427L58.2688 21.024ZM52.4767 18.2535H54.4985L53.4854 17.2449L52.4767 18.2535ZM51.2875 19.4384H55.6877L55.0314 18.7821H51.9438L51.2875 19.4384ZM49.9749 20.751H57.0047L56.2251 19.9713H50.7589L49.9749 20.751ZM54.5425 23.7505H52.4283L53.4854 24.8076L54.5425 23.7505ZM55.8155 22.482H51.1553L51.8953 23.2176H55.0755L55.8155 22.482ZM56.3484 21.9534L57.0179 21.2839H49.9573L50.6268 21.9534H56.3484Z",
    fill: "#008A4B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1143 58.2695L34.6953 54.6797L38.2807 58.2695H31.1143Z",
    fill: "#75B043"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8932 55.8778H33.5015L34.6952 54.6797L35.8932 55.8778Z",
    fill: "#008A4B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8932 58.2689H33.5015L34.6952 57.0708L35.8932 58.2689Z",
    fill: "#008A4B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6949 57.0716H32.3076L33.5012 55.8779L34.6949 57.0716Z",
    fill: "#008A4B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5016 58.2689H31.1143L32.308 57.0708L33.5016 58.2689Z",
    fill: "#008A4B"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0865 57.0716H34.6948L35.8928 55.8779L37.0865 57.0716Z",
    fill: "#008A4B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2809 58.2689H35.8936L37.0872 57.0708L38.2809 58.2689Z",
    fill: "#008A4B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2807 48.7026L34.6953 52.288L31.1143 48.7026H38.2807Z",
    fill: "#75B043"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5015 51.0938H35.8932L34.6952 52.2874L33.5015 51.0938Z",
    fill: "#008A4B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5015 48.7026H35.8932L34.6952 49.8963L33.5015 48.7026Z",
    fill: "#008A4B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6948 49.896H37.0865L35.8928 51.0941L34.6948 49.896Z",
    fill: "#008A4B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8936 48.7026H38.2809L37.0872 49.8963L35.8936 48.7026Z",
    fill: "#008A4B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3076 49.896H34.6949L33.5012 51.0941L32.3076 49.896Z",
    fill: "#008A4B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1143 48.7026H33.5016L32.308 49.8963L31.1143 48.7026Z",
    fill: "#008A4B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M39.567 58.2695L43.1479 54.6797L46.7333 58.2695H39.567Z",
    fill: "#75B043"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3459 55.8778H41.9542L43.1478 54.6797L44.3459 55.8778Z",
    fill: "#008A4B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3459 58.2689H41.9542L43.1478 57.0708L44.3459 58.2689Z",
    fill: "#008A4B"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1475 57.0716H40.7602L41.9539 55.8779L43.1475 57.0716Z",
    fill: "#008A4B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9543 58.2689H39.567L40.7606 57.0708L41.9543 58.2689Z",
    fill: "#008A4B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5391 57.0716H43.1474L44.3455 55.8779L45.5391 57.0716Z",
    fill: "#008A4B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7335 58.2689H44.3462L45.5398 57.0708L46.7335 58.2689Z",
    fill: "#008A4B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7333 48.7026L43.1479 52.288L39.567 48.7026H46.7333Z",
    fill: "#75B043"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9542 51.0938H44.3459L43.1478 52.2874L41.9542 51.0938Z",
    fill: "#008A4B"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9542 48.7026H44.3459L43.1478 49.8963L41.9542 48.7026Z",
    fill: "#008A4B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1474 49.896H45.5391L44.3455 51.0941L43.1474 49.896Z",
    fill: "#008A4B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3462 48.7026H46.7335L45.5398 49.8963L44.3462 48.7026Z",
    fill: "#008A4B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7602 49.896H43.1475L41.9539 51.0941L40.7602 49.896Z",
    fill: "#008A4B"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M39.567 48.7026H41.9543L40.7606 49.8963L39.567 48.7026Z",
    fill: "#008A4B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9762 48.7026L43.2531 52.9883L47.5344 48.7026V49.6981L43.7509 53.4861L44.068 53.7988L44.6142 54.3494V53.2482L45.1471 52.7197V54.8823L46.0589 55.7941V51.8035L46.5919 51.2705V56.3271L47.5344 57.2741V58.2695L43.2531 53.9838L38.9762 58.2695L34.6949 53.9838L30.418 58.2695V57.2741L34.2016 53.4861L33.9065 53.191L33.3868 52.6712V53.6579L32.8538 54.1908V52.1383L31.942 51.2221V55.1026L31.4091 55.6355V50.6891L30.418 49.6981V48.7026L34.6949 52.9883L38.9762 48.7026ZM36.2057 54.4947V52.473L35.1971 53.4861L36.2057 54.4947ZM37.395 55.684V51.2838L36.7387 51.94V55.0277L37.395 55.684ZM38.7032 56.9966V49.9668L37.9235 50.7464V56.2125L38.7032 56.9966ZM41.7027 52.429V54.5432L42.7598 53.4861L41.7027 52.429ZM40.4342 51.156V55.8161L41.1698 55.0761V51.896L40.4342 51.156ZM39.9056 50.6231L39.2361 49.9536V57.0142L39.9056 56.3447V50.6231Z",
    fill: "#008A4B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 58.2695L16.746 54.6797L20.327 58.2695H13.165Z",
    fill: "#75B043"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9396 55.8778H15.5523L16.746 54.6797L17.9396 55.8778Z",
    fill: "#008A4B"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9396 58.2689H15.5523L16.746 57.0708L17.9396 58.2689Z",
    fill: "#008A4B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 57.0716H14.3591L15.5527 55.8779L16.7464 57.0716Z",
    fill: "#008A4B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5524 58.2689H13.1651L14.3588 57.0708L15.5524 58.2689Z",
    fill: "#008A4B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1336 57.0716H16.7463L17.9399 55.8779L19.1336 57.0716Z",
    fill: "#008A4B"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3268 58.2689H17.9395L19.1332 57.0708L20.3268 58.2689Z",
    fill: "#008A4B"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M20.327 48.7026L16.746 52.288L13.165 48.7026H20.327Z",
    fill: "#75B043"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5523 51.0938H17.9396L16.746 52.2874L15.5523 51.0938Z",
    fill: "#008A4B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5523 48.7026H17.9396L16.746 49.8963L15.5523 48.7026Z",
    fill: "#008A4B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7463 49.896H19.1336L17.9399 51.0941L16.7463 49.896Z",
    fill: "#008A4B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9395 48.7026H20.3268L19.1332 49.8963L17.9395 48.7026Z",
    fill: "#008A4B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3591 49.896H16.7464L15.5527 51.0941L14.3591 49.896Z",
    fill: "#008A4B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 48.7026H15.5524L14.3587 49.8963L13.165 48.7026Z",
    fill: "#008A4B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6177 58.2695L25.1987 54.6797L28.7796 58.2695H21.6177Z",
    fill: "#75B043"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3923 55.8778H24.0049L25.1986 54.6797L26.3923 55.8778Z",
    fill: "#008A4B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3923 58.2689H24.0049L25.1986 57.0708L26.3923 58.2689Z",
    fill: "#008A4B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M25.199 57.0716H22.8117L24.0054 55.8779L25.199 57.0716Z",
    fill: "#008A4B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0051 58.2689H21.6177L22.8114 57.0708L24.0051 58.2689Z",
    fill: "#008A4B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5865 57.0716H25.1992L26.3928 55.8779L27.5865 57.0716Z",
    fill: "#008A4B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7797 58.2689H26.3924L27.5861 57.0708L28.7797 58.2689Z",
    fill: "#008A4B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7796 48.7026L25.1987 52.288L21.6177 48.7026H28.7796Z",
    fill: "#75B043"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 51.0938H26.3923L25.1986 52.2874L24.0049 51.0938Z",
    fill: "#008A4B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 48.7026H26.3923L25.1986 49.8963L24.0049 48.7026Z",
    fill: "#008A4B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 49.896H27.5865L26.3928 51.0941L25.1992 49.896Z",
    fill: "#008A4B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3924 48.7026H28.7797L27.5861 49.8963L26.3924 48.7026Z",
    fill: "#008A4B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8117 49.896H25.199L24.0054 51.0941L22.8117 49.896Z",
    fill: "#008A4B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6177 48.7026H24.005L22.8113 49.8963L21.6177 48.7026Z",
    fill: "#008A4B"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0279 48.7026L25.3048 52.9883L29.5861 48.7026V49.6981L25.8025 53.4861L26.1152 53.7988L26.6658 54.3494V53.2482L27.1944 52.7197V54.8823L28.1061 55.7941V51.8035L28.6391 51.2705V56.3271L29.5861 57.2741V58.2695L25.3048 53.9838L21.0279 58.2695L16.7466 53.9838L12.4697 58.2695V57.2741L16.2488 53.4861L15.9537 53.191L15.434 52.6712V53.6579L14.9054 54.1908V52.1383L13.9937 51.2221V55.1026L13.4607 55.6355V50.6891L12.4697 49.6981V48.7026L16.7466 52.9883L21.0279 48.7026ZM18.253 54.4947V52.473L17.2443 53.4861L18.253 54.4947ZM19.4422 55.684V51.2838L18.7859 51.94V55.0277L19.4422 55.684ZM20.7548 56.9966V49.9668L19.9752 50.7464V56.2125L20.7548 56.9966ZM23.7543 52.429V54.5432L24.8115 53.4861L23.7543 52.429ZM22.4814 51.156V55.8161L23.2214 55.0761V51.896L22.4814 51.156ZM21.9484 50.6231L21.2834 49.9536V57.0142L21.9484 56.3447V50.6231Z",
    fill: "#008A4B"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1143 11.2983L34.6953 7.7085L38.2807 11.2983H31.1143Z",
    fill: "#75B043"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8932 8.90656H33.5015L34.6952 7.7085L35.8932 8.90656Z",
    fill: "#008A4B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8932 11.2977H33.5015L34.6952 10.0996L35.8932 11.2977Z",
    fill: "#008A4B"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6949 10.0999H32.3076L33.5012 8.90625L34.6949 10.0999Z",
    fill: "#008A4B"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5016 11.2977H31.1143L32.308 10.0996L33.5016 11.2977Z",
    fill: "#008A4B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0865 10.0999H34.6948L35.8928 8.90625L37.0865 10.0999Z",
    fill: "#008A4B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2809 11.2977H35.8936L37.0872 10.0996L38.2809 11.2977Z",
    fill: "#008A4B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2807 1.73145L34.6953 5.31683L31.1143 1.73145H38.2807Z",
    fill: "#75B043"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5015 4.12256H35.8932L34.6952 5.31623L33.5015 4.12256Z",
    fill: "#008A4B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5015 1.73145H35.8932L34.6952 2.9251L33.5015 1.73145Z",
    fill: "#008A4B"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6948 2.92432H37.0865L35.8928 4.12238L34.6948 2.92432Z",
    fill: "#008A4B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8936 1.73145H38.2809L37.0872 2.9251L35.8936 1.73145Z",
    fill: "#008A4B"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3076 2.92432H34.6949L33.5012 4.12238L32.3076 2.92432Z",
    fill: "#008A4B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1143 1.73145H33.5016L32.308 2.9251L31.1143 1.73145Z",
    fill: "#008A4B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M39.567 11.2983L43.1479 7.7085L46.7333 11.2983H39.567Z",
    fill: "#75B043"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3459 8.90656H41.9542L43.1478 7.7085L44.3459 8.90656Z",
    fill: "#008A4B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3459 11.2977H41.9542L43.1478 10.0996L44.3459 11.2977Z",
    fill: "#008A4B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1475 10.0999H40.7602L41.9539 8.90625L43.1475 10.0999Z",
    fill: "#008A4B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9543 11.2977H39.567L40.7606 10.0996L41.9543 11.2977Z",
    fill: "#008A4B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5391 10.0999H43.1474L44.3455 8.90625L45.5391 10.0999Z",
    fill: "#008A4B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7335 11.2977H44.3462L45.5398 10.0996L46.7335 11.2977Z",
    fill: "#008A4B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7333 1.73145L43.1479 5.31683L39.567 1.73145H46.7333Z",
    fill: "#75B043"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9542 4.12256H44.3459L43.1478 5.31623L41.9542 4.12256Z",
    fill: "#008A4B"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9542 1.73145H44.3459L43.1478 2.9251L41.9542 1.73145Z",
    fill: "#008A4B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1474 2.92432H45.5391L44.3455 4.12238L43.1474 2.92432Z",
    fill: "#008A4B"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3462 1.73145H46.7335L45.5398 2.9251L44.3462 1.73145Z",
    fill: "#008A4B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7602 2.92432H43.1475L41.9539 4.12238L40.7602 2.92432Z",
    fill: "#008A4B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M39.567 1.73145H41.9543L40.7606 2.9251L39.567 1.73145Z",
    fill: "#008A4B"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9762 1.73145L43.2531 6.01717L47.5344 1.73145V2.7269L43.7509 6.51488L44.068 6.82762L44.6142 7.3782V6.27704L45.1471 5.74407V7.91116L46.0589 8.82292V4.83232L46.5919 4.29935V9.35588L47.5344 10.3029V11.2983L43.2531 7.01261L38.9762 11.2983L34.6949 7.01261L30.418 11.2983V10.3029L34.2016 6.51488L33.9065 6.21978L33.3868 5.69562V6.68667L32.8538 7.21963V5.16706L31.942 4.2509V8.13139L31.4091 8.66435V3.71794L30.418 2.7269V1.73145L34.6949 6.01717L38.9762 1.73145ZM36.2057 7.52355V5.50182L35.1971 6.51488L36.2057 7.52355ZM37.395 8.71281V4.30816L36.7387 4.96886V8.05211L37.395 8.71281ZM38.7032 10.0254V2.99998L37.9235 3.7796V9.24577L38.7032 10.0254ZM41.7027 5.45337V7.57201L42.7598 6.51488L41.7027 5.45337ZM40.4342 4.18043V8.84055L41.1698 8.10055V4.9204L40.4342 4.18043ZM39.9056 3.64747L39.2361 2.97795V10.0386L39.9056 9.36909V3.64747Z",
    fill: "#008A4B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 11.2983L16.746 7.7085L20.327 11.2983H13.165Z",
    fill: "#75B043"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9396 8.90656H15.5523L16.746 7.7085L17.9396 8.90656Z",
    fill: "#008A4B"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9396 11.2977H15.5523L16.746 10.0996L17.9396 11.2977Z",
    fill: "#008A4B"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 10.0999H14.3591L15.5527 8.90625L16.7464 10.0999Z",
    fill: "#008A4B"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5524 11.2977H13.1651L14.3588 10.0996L15.5524 11.2977Z",
    fill: "#008A4B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1336 10.0999H16.7463L17.9399 8.90625L19.1336 10.0999Z",
    fill: "#008A4B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3268 11.2977H17.9395L19.1332 10.0996L20.3268 11.2977Z",
    fill: "#008A4B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M20.327 1.73145L16.746 5.31683L13.165 1.73145H20.327Z",
    fill: "#75B043"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5523 4.12256H17.9396L16.746 5.31623L15.5523 4.12256Z",
    fill: "#008A4B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5523 1.73145H17.9396L16.746 2.9251L15.5523 1.73145Z",
    fill: "#008A4B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7463 2.92432H19.1336L17.9399 4.12238L16.7463 2.92432Z",
    fill: "#008A4B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9395 1.73145H20.3268L19.1332 2.9251L17.9395 1.73145Z",
    fill: "#008A4B"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3591 2.92432H16.7464L15.5527 4.12238L14.3591 2.92432Z",
    fill: "#008A4B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M13.165 1.73145H15.5524L14.3587 2.9251L13.165 1.73145Z",
    fill: "#008A4B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6177 11.2983L25.1987 7.7085L28.7796 11.2983H21.6177Z",
    fill: "#75B043"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3923 8.90656H24.0049L25.1986 7.7085L26.3923 8.90656Z",
    fill: "#008A4B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3923 11.2977H24.0049L25.1986 10.0996L26.3923 11.2977Z",
    fill: "#008A4B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M25.199 10.0999H22.8117L24.0054 8.90625L25.199 10.0999Z",
    fill: "#008A4B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0051 11.2977H21.6177L22.8114 10.0996L24.0051 11.2977Z",
    fill: "#008A4B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5865 10.0999H25.1992L26.3928 8.90625L27.5865 10.0999Z",
    fill: "#008A4B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7797 11.2977H26.3924L27.5861 10.0996L28.7797 11.2977Z",
    fill: "#008A4B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7796 1.73145L25.1987 5.31683L21.6177 1.73145H28.7796Z",
    fill: "#75B043"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 4.12256H26.3923L25.1986 5.31623L24.0049 4.12256Z",
    fill: "#008A4B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 1.73145H26.3923L25.1986 2.9251L24.0049 1.73145Z",
    fill: "#008A4B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 2.92432H27.5865L26.3928 4.12238L25.1992 2.92432Z",
    fill: "#008A4B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3924 1.73145H28.7797L27.5861 2.9251L26.3924 1.73145Z",
    fill: "#008A4B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8117 2.92432H25.199L24.0054 4.12238L22.8117 2.92432Z",
    fill: "#008A4B"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6177 1.73145H24.005L22.8113 2.9251L21.6177 1.73145Z",
    fill: "#008A4B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0279 1.73145L25.3048 6.01717L29.5861 1.73145V2.7269L25.8025 6.51488L26.1152 6.82762L26.6658 7.3782V6.27704L27.1944 5.74407V7.91116L28.1061 8.82292V4.83232L28.6391 4.29935V9.35588L29.5861 10.3029V11.2983L25.3048 7.01261L21.0279 11.2983L16.7466 7.01261L12.4697 11.2983V10.3029L16.2488 6.51488L15.9537 6.21978L15.434 5.69562V6.68667L14.9054 7.21963V5.16706L13.9937 4.2509V8.13139L13.4607 8.66435V3.71794L12.4697 2.7269V1.73145L16.7466 6.01717L21.0279 1.73145ZM18.253 7.52355V5.50182L17.2443 6.51488L18.253 7.52355ZM19.4422 8.71281V4.30816L18.7859 4.96886V8.05211L19.4422 8.71281ZM20.7548 10.0254V2.99998L19.9752 3.7796V9.24577L20.7548 10.0254ZM23.7543 5.45337V7.57201L24.8115 6.51488L23.7543 5.45337ZM22.4814 4.18043V8.84055L23.2214 8.10055V4.9204L22.4814 4.18043ZM21.9484 3.64747L21.2834 2.97795V10.0386L21.9484 9.36909V3.64747Z",
    fill: "#008A4B"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8559 32.9821C24.0453 32.2333 23.8647 31.4053 23.3054 30.7886C22.746 30.1676 21.9399 29.9121 21.1735 30.0266C20.9841 30.7754 21.1603 31.6035 21.7197 32.2245C22.2791 32.8412 23.0895 33.0966 23.8559 32.9821Z",
    fill: "#75B043"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4418 25.9697C22.6312 25.2209 22.4506 24.3884 21.8956 23.7717C21.3362 23.1551 20.5257 22.8952 19.7593 23.0097C19.5699 23.7629 19.7505 24.591 20.3099 25.2076C20.8693 25.8243 21.6754 26.0842 22.4418 25.9697Z",
    fill: "#75B043"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3146 19.0986C17.504 18.3454 17.3278 17.5173 16.7684 16.9006C16.209 16.284 15.3985 16.0241 14.6321 16.1386C14.4427 16.8874 14.6233 17.7199 15.1827 18.3366C15.7421 18.9532 16.5482 19.2131 17.3146 19.0986Z",
    fill: "#75B043"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M27.256 21.8156C27.6877 21.1725 27.8022 20.3312 27.485 19.5604C27.1679 18.794 26.494 18.2743 25.7364 18.1245C25.3003 18.7676 25.1902 19.6045 25.5074 20.3753C25.8201 21.1461 26.494 21.6614 27.256 21.8156Z",
    fill: "#75B043"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9051 29.7264C14.2885 30.2858 14.0286 31.0918 14.1431 31.8582C14.8963 32.0476 15.7244 31.8715 16.341 31.3121C16.9577 30.7527 17.2175 29.9466 17.103 29.1802C16.3542 28.9908 15.5218 29.167 14.9051 29.7264Z",
    fill: "#75B043"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8732 38.4002C23.4899 37.8408 23.7498 37.0304 23.6352 36.264C22.882 36.0746 22.054 36.2552 21.4373 36.8146C20.8207 37.3739 20.5608 38.18 20.6753 38.9464C21.4285 39.1358 22.2566 38.9596 22.8732 38.4002Z",
    fill: "#75B043"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6896 24.7012C15.3107 24.1418 15.5661 23.3358 15.4516 22.5694C14.7028 22.38 13.8747 22.5562 13.2537 23.1156C12.637 23.6749 12.3816 24.4854 12.4917 25.2518C13.2449 25.4368 14.073 25.2606 14.6896 24.7012Z",
    fill: "#75B043"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8732 17.6885C23.4899 17.1291 23.7498 16.3231 23.6352 15.5567C22.882 15.3673 22.054 15.5435 21.4373 16.1029C20.8207 16.6622 20.5608 17.4683 20.6753 18.2347C21.4285 18.4241 22.2566 18.2479 22.8732 17.6885Z",
    fill: "#75B043"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1094 23.7717C37.55 24.3884 37.3738 25.2209 37.5632 25.9697C38.3296 26.0842 39.1357 25.8243 39.6951 25.2076C40.2545 24.591 40.4306 23.7629 40.2412 23.0097C39.4748 22.8952 38.6688 23.1551 38.1094 23.7717Z",
    fill: "#75B043"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6902 19.0986C43.4566 19.2131 44.2626 18.9532 44.822 18.3366C45.3814 17.7199 45.5576 16.8874 45.3682 16.1386C44.6018 16.0241 43.7957 16.284 43.2364 16.9006C42.677 17.5173 42.5008 18.3454 42.6902 19.0986Z",
    fill: "#75B043"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 26.5425C36.1272 26.5425 33.2378 28.0092 31.313 30.3128C32.26 25.4501 36.5545 21.7634 41.6903 21.7634H47.5352V19.5303H41.6903C38.2679 19.5303 35.0525 20.8605 32.6343 23.2786C32.0676 23.8483 31.5626 24.4561 31.1192 25.1021V22.1246C31.1192 18.0591 34.427 14.7512 38.4925 14.7512H42.8575V12.5137H38.4925C34.819 12.5137 31.6169 14.5927 30.0004 17.6319C28.3839 14.5927 25.1861 12.5137 21.5082 12.5137H17.1432V14.7512H21.5082C25.5737 14.7512 28.8816 18.0591 28.8816 22.1246V25.1021C28.4382 24.4561 27.9331 23.8483 27.3664 23.2786C24.9483 20.8605 21.7329 19.5303 18.3105 19.5303H12.4699V21.7634H18.3105C23.4507 21.7634 27.7408 25.4501 28.6878 30.3128C26.7674 28.0092 23.8779 26.5425 20.6493 26.5425H12.4699V28.78H20.6493C24.8161 28.78 28.2738 31.8897 28.8111 35.9155C27.3664 34.4576 25.3667 33.5547 23.16 33.5547H19.4821V35.7922H23.16C25.9217 35.7922 28.2341 37.7567 28.7671 40.3642C28.2121 43.1436 25.7543 45.2446 22.8164 45.2446H21.821V47.4821H22.8164C25.882 47.4821 28.5645 45.8128 30.0004 43.333C31.4407 45.8128 34.1231 47.4821 37.1887 47.4821H38.1842V45.2446H37.1887C34.2464 45.2446 31.7887 43.1436 31.2381 40.3642C31.771 37.7567 34.0791 35.7922 36.8408 35.7922H40.5231V33.5547H36.8408C34.634 33.5547 32.6344 34.4576 31.194 35.9155C31.7314 31.8897 35.1846 28.78 39.3514 28.78H47.5352V26.5425H39.3514Z",
    fill: "#75B043"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5193 19.5604C32.2022 20.3312 32.3167 21.1725 32.7484 21.8156C33.506 21.6614 34.1799 21.1461 34.497 20.3753C34.8141 19.6045 34.6996 18.7676 34.268 18.1245C33.506 18.2743 32.8365 18.794 32.5193 19.5604Z",
    fill: "#75B043"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0945 29.7264C44.4778 29.167 43.6498 28.9908 42.8966 29.1802C42.7821 29.9466 43.0419 30.7527 43.6586 31.3121C44.2752 31.8715 45.1077 32.0476 45.8565 31.8582C45.971 31.0918 45.7111 30.2858 45.0945 29.7264Z",
    fill: "#75B043"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3646 36.264C36.2544 37.0304 36.5099 37.8408 37.1265 38.4002C37.7476 38.9596 38.5757 39.1358 39.3245 38.9464C39.439 38.18 39.1835 37.3739 38.5625 36.8146C37.9458 36.2552 37.1177 36.0746 36.3646 36.264Z",
    fill: "#75B043"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5489 22.5694C44.4344 23.3358 44.6943 24.1418 45.3109 24.7012C45.9276 25.2606 46.7556 25.4368 47.5088 25.2518C47.6234 24.4854 47.3635 23.6749 46.7468 23.1156C46.1302 22.5562 45.3021 22.38 44.5489 22.5694Z",
    fill: "#75B043"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3646 15.5567C36.2544 16.3231 36.5099 17.1291 37.1265 17.6885C37.7476 18.2479 38.5757 18.4241 39.3245 18.2347C39.439 17.4683 39.1835 16.6622 38.5625 16.1029C37.9458 15.5435 37.1177 15.3673 36.3646 15.5567Z",
    fill: "#75B043"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8204 47.5303H38.1837V45.1958H21.8204V47.5303Z",
    fill: "#75B043"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 13.633L31.1719 12.4658H28.833L30.0002 13.633Z",
    fill: "#008A4B"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9711 15.9703C18.9711 16.3359 18.676 16.631 18.3104 16.631C17.9492 16.631 17.6541 16.3359 17.6541 15.9703C17.6541 15.6047 17.9492 15.3096 18.3104 15.3096C18.676 15.3096 18.9711 15.6047 18.9711 15.9703Z",
    fill: "#008A4B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6322 25.3218C16.6322 25.6874 16.3371 25.9825 15.9759 25.9825C15.6103 25.9825 15.3152 25.6874 15.3152 25.3218C15.3152 24.9562 15.6103 24.6611 15.9759 24.6611C16.3371 24.6611 16.6322 24.9562 16.6322 25.3218Z",
    fill: "#008A4B"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2973 13.6319C14.2973 13.9975 14.0022 14.2926 13.6366 14.2926C13.2711 14.2926 12.976 13.9975 12.976 13.6319C12.976 13.2707 13.2711 12.9712 13.6366 12.9712C14.0022 12.9712 14.2973 13.2707 14.2973 13.6319Z",
    fill: "#008A4B"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9873 32.335C25.9873 32.7006 25.6878 32.9957 25.3267 32.9957C24.9611 32.9957 24.666 32.7006 24.666 32.335C24.666 31.9738 24.9611 31.6787 25.3267 31.6787C25.6878 31.6787 25.9873 31.9738 25.9873 32.335Z",
    fill: "#008A4B"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9711 32.335C18.9711 32.7006 18.676 32.9957 18.3104 32.9957C17.9492 32.9957 17.6541 32.7006 17.6541 32.335C17.6541 31.9738 17.9492 31.6787 18.3104 31.6787C18.676 31.6787 18.9711 31.9738 18.9711 32.335Z",
    fill: "#008A4B"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0292 15.9703C41.0292 16.3359 41.3243 16.631 41.6899 16.631C42.0555 16.631 42.3506 16.3359 42.3506 15.9703C42.3506 15.6047 42.0555 15.3096 41.6899 15.3096C41.3243 15.3096 41.0292 15.6047 41.0292 15.9703Z",
    fill: "#008A4B"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3679 25.3218C43.3679 25.6874 43.663 25.9825 44.0286 25.9825C44.3942 25.9825 44.6893 25.6874 44.6893 25.3218C44.6893 24.9562 44.3942 24.6611 44.0286 24.6611C43.663 24.6611 43.3679 24.9562 43.3679 25.3218Z",
    fill: "#008A4B"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7073 13.6319C45.7073 13.9975 46.0024 14.2926 46.368 14.2926C46.7292 14.2926 47.0243 13.9975 47.0243 13.6319C47.0243 13.2707 46.7292 12.9712 46.368 12.9712C46.0024 12.9712 45.7073 13.2707 45.7073 13.6319Z",
    fill: "#008A4B"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0174 32.335C34.0174 32.7006 34.3125 32.9957 34.6781 32.9957C35.0437 32.9957 35.3388 32.7006 35.3388 32.335C35.3388 31.9738 35.0437 31.6787 34.6781 31.6787C34.3125 31.6787 34.0174 31.9738 34.0174 32.335Z",
    fill: "#008A4B"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0292 32.335C41.0292 32.7006 41.3243 32.9957 41.6899 32.9957C42.0555 32.9957 42.3506 32.7006 42.3506 32.335C42.3506 31.9738 42.0555 31.6787 41.6899 31.6787C41.3243 31.6787 41.0292 31.9738 41.0292 32.335Z",
    fill: "#008A4B"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8573 45.1909H40.5228V47.5254H42.8573V45.1909Z",
    fill: "#008A4B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1956 45.1909H42.8567V47.5254H45.1956V45.1909Z",
    fill: "#75B043"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M47.535 45.1909H45.1961V47.5254H47.535V45.1909Z",
    fill: "#008A4B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1956 42.8569H42.8567V45.1914H45.1956V42.8569Z",
    fill: "#008A4B"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M47.535 42.8569H45.1961V45.1914H47.535V42.8569Z",
    fill: "#75B043"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M47.535 40.5229H45.1961V42.8574H47.535V40.5229Z",
    fill: "#008A4B"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M47.535 38.1797H45.1961V40.5141H47.535V38.1797Z",
    fill: "#75B043"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M47.535 35.8486H45.1961V38.1787H47.535V35.8486Z",
    fill: "#008A4B"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 45.1909H19.4818V47.5254H17.1429V45.1909Z",
    fill: "#008A4B"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8035 45.1909H17.1424V47.5254H14.8035V45.1909Z",
    fill: "#75B043"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4696 45.1909H14.8041V47.5254H12.4696V45.1909Z",
    fill: "#008A4B"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8035 42.8569H17.1424V45.1914H14.8035V42.8569Z",
    fill: "#008A4B"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4696 42.8569H14.8041V45.1914H12.4696V42.8569Z",
    fill: "#75B043"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4696 40.5229H14.8041V42.8574H12.4696V40.5229Z",
    fill: "#008A4B"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4696 38.1797H14.8041V40.5141H12.4696V38.1797Z",
    fill: "#75B043"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4697 35.8486H14.8041V38.1787H12.4697V35.8486Z",
    fill: "#008A4B"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3406 2.36572H48.702V1.73145H49.3406V2.36572Z",
    fill: "#75B043"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9797 2.36572H49.3411V1.73145H49.9797V2.36572Z",
    fill: "#75B043"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6182 2.36572H49.9796V1.73145H50.6182V2.36572Z",
    fill: "#75B043"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 3.00342H48.702V2.36475H49.3407V3.00342Z",
    fill: "#75B043"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9797 3.00342H49.3411V2.36475H49.9797V3.00342Z",
    fill: "#75B043"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 3.64208H48.702V3.00342H49.3407V3.64208Z",
    fill: "#75B043"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 4.28175H48.702V3.64307H49.3407V4.28175Z",
    fill: "#75B043"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 4.28175H49.3411V3.64307H49.9798V4.28175Z",
    fill: "#75B043"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 4.28175H49.9796V3.64307H50.6183V4.28175Z",
    fill: "#75B043"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 4.9204H48.7021V4.28174H49.3408V4.9204Z",
    fill: "#75B043"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 4.9204H49.3411V4.28174H49.9798V4.9204Z",
    fill: "#75B043"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 5.55419H48.7021V4.91992H49.3408V5.55419Z",
    fill: "#75B043"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 6.19239H48.702V5.55371H49.3407V6.19239Z",
    fill: "#75B043"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 6.19239H49.3411V5.55371H49.9798V6.19239Z",
    fill: "#75B043"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 6.19239H49.9796V5.55371H50.6183V6.19239Z",
    fill: "#75B043"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 6.83251H48.7021V6.19385H49.3408V6.83251Z",
    fill: "#75B043"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 6.83251H49.3411V6.19385H49.9798V6.83251Z",
    fill: "#75B043"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 7.47071H48.7021V6.83203H49.3408V7.47071Z",
    fill: "#75B043"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 8.10889H48.702V7.47021H49.3407V8.10889Z",
    fill: "#75B043"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 8.10889H49.3411V7.47021H49.9798V8.10889Z",
    fill: "#75B043"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 8.10889H49.9796V7.47021H50.6183V8.10889Z",
    fill: "#75B043"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 8.74267H48.7021V8.1084H49.3408V8.74267Z",
    fill: "#75B043"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 8.74267H49.3411V8.1084H49.9798V8.74267Z",
    fill: "#75B043"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 9.38281H48.7021V8.74414H49.3408V9.38281Z",
    fill: "#75B043"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 10.021H48.702V9.38232H49.3407V10.021Z",
    fill: "#75B043"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 10.021H49.3411V9.38232H49.9798V10.021Z",
    fill: "#75B043"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 10.021H49.9796V9.38232H50.6183V10.021Z",
    fill: "#75B043"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 10.6597H48.7021V10.021H49.3408V10.6597Z",
    fill: "#75B043"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 11.2979H48.7021V10.6592H49.3408V11.2979Z",
    fill: "#75B043"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2565 2.36572H50.6179V1.73145H51.2565V2.36572Z",
    fill: "#75B043"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 2.36572H51.2572V1.73145H51.8915V2.36572Z",
    fill: "#75B043"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5303 2.36572H51.8917V1.73145H52.5303V2.36572Z",
    fill: "#75B043"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 3.00342H50.618V2.36475H51.2567V3.00342Z",
    fill: "#75B043"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 3.00342H51.2572V2.36475H51.8915V3.00342Z",
    fill: "#75B043"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 3.64208H50.618V3.00342H51.2567V3.64208Z",
    fill: "#75B043"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 2.36572H52.53V1.73145H53.1686V2.36572Z",
    fill: "#75B043"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M53.807 2.36572H53.1683V1.73145H53.807V2.36572Z",
    fill: "#75B043"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4462 2.36572H53.8075V1.73145H54.4462V2.36572Z",
    fill: "#75B043"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 3.00342H52.53V2.36475H53.1686V3.00342Z",
    fill: "#75B043"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M53.807 3.00342H53.1683V2.36475H53.807V3.00342Z",
    fill: "#75B043"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 3.64208H52.53V3.00342H53.1686V3.64208Z",
    fill: "#75B043"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5303 4.28175H51.8917V3.64307H52.5303V4.28175Z",
    fill: "#75B043"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 4.9204H51.2572V4.28174H51.8915V4.9204Z",
    fill: "#75B043"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 5.55419H50.618V4.91992H51.2567V5.55419Z",
    fill: "#75B043"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 2.36572H54.4458V1.73145H55.0801V2.36572Z",
    fill: "#75B043"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7189 2.36572H55.0802V1.73145H55.7189V2.36572Z",
    fill: "#75B043"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3574 2.36572H55.7188V1.73145H56.3574V2.36572Z",
    fill: "#75B043"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 3.00342H54.4458V2.36475H55.0801V3.00342Z",
    fill: "#75B043"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7189 3.00342H55.0802V2.36475H55.7189V3.00342Z",
    fill: "#75B043"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 3.64208H54.4458V3.00342H55.0801V3.64208Z",
    fill: "#75B043"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4462 4.28175H53.8075V3.64307H54.4462V4.28175Z",
    fill: "#75B043"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M53.807 4.9204H53.1683V4.28174H53.807V4.9204Z",
    fill: "#75B043"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 5.55419H52.53V4.91992H53.1686V5.55419Z",
    fill: "#75B043"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5303 6.19239H51.8917V5.55371H52.5303V6.19239Z",
    fill: "#75B043"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 6.83251H51.2572V6.19385H51.8915V6.83251Z",
    fill: "#75B043"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 7.47071H50.618V6.83203H51.2567V7.47071Z",
    fill: "#75B043"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 2.36572H56.3577V1.73145H56.9963V2.36572Z",
    fill: "#75B043"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6303 2.36572H56.9961V1.73145H57.6303V2.36572Z",
    fill: "#75B043"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2692 2.36572H57.6306V1.73145H58.2692V2.36572Z",
    fill: "#75B043"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 3.00342H56.3576V2.36475H56.9963V3.00342Z",
    fill: "#75B043"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 3.64208H56.3576V3.00342H56.9963V3.64208Z",
    fill: "#75B043"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 10.6592H58.2692V11.2979H57.6306V10.6592Z",
    fill: "#75B043"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 10.6592H57.6303V11.2979H56.9961V10.6592Z",
    fill: "#75B043"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3576 10.6592H56.9963V11.2979H56.3576V10.6592Z",
    fill: "#75B043"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 10.021H58.2692V10.6597H57.6306V10.021Z",
    fill: "#75B043"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 10.021H57.6303V10.6597H56.9961V10.021Z",
    fill: "#75B043"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 9.38232H58.2692V10.021H57.6306V9.38232Z",
    fill: "#75B043"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 8.74414H58.2692V9.38281H57.6306V8.74414Z",
    fill: "#75B043"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 8.74414H57.6303V9.38281H56.9961V8.74414Z",
    fill: "#75B043"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3576 8.74414H56.9963V9.38281H56.3576V8.74414Z",
    fill: "#75B043"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 8.1084H58.2692V8.74267H57.6306V8.1084Z",
    fill: "#75B043"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 8.1084H57.6303V8.74267H56.9961V8.1084Z",
    fill: "#75B043"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 7.47021H58.2692V8.10889H57.6306V7.47021Z",
    fill: "#75B043"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 6.83203H58.2691V7.47071H57.6304V6.83203Z",
    fill: "#75B043"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M56.996 6.83203H57.6302V7.47071H56.996V6.83203Z",
    fill: "#75B043"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3577 6.83203H56.9964V7.47071H56.3577V6.83203Z",
    fill: "#75B043"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 7.47021H56.3571V8.10889H55.7184V7.47021Z",
    fill: "#75B043"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 8.1084H55.7188V8.74267H55.0801V8.1084Z",
    fill: "#75B043"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4457 8.74414H55.08V9.38281H54.4457V8.74414Z",
    fill: "#75B043"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 6.19385H58.2691V6.83251H57.6304V6.19385Z",
    fill: "#75B043"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M56.996 6.19385H57.6302V6.83251H56.996V6.19385Z",
    fill: "#75B043"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 5.55371H58.2691V6.19239H57.6304V5.55371Z",
    fill: "#75B043"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 4.91992H58.2693V5.55419H57.6306V4.91992Z",
    fill: "#75B043"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9962 4.91992H57.6304V5.55419H56.9962V4.91992Z",
    fill: "#75B043"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3577 4.91992H56.9963V5.55419H56.3577V4.91992Z",
    fill: "#75B043"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7186 5.55322H56.3573V6.1919H55.7186V5.55322Z",
    fill: "#75B043"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 6.19385H55.7188V6.83251H55.0801V6.19385Z",
    fill: "#75B043"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4457 6.83203H55.0799V7.47071H54.4457V6.83203Z",
    fill: "#75B043"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 7.47021H54.446V8.10889H53.8074V7.47021Z",
    fill: "#75B043"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1682 8.1084H53.8068V8.74267H53.1682V8.1084Z",
    fill: "#75B043"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5298 8.74414H53.1685V9.38281H52.5298V8.74414Z",
    fill: "#75B043"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 4.28174H58.2693V4.9204H57.6306V4.28174Z",
    fill: "#75B043"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9962 4.28174H57.6304V4.9204H56.9962V4.28174Z",
    fill: "#75B043"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 3.64307H58.2693V4.28175H57.6306V3.64307Z",
    fill: "#75B043"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6307 3.00342H58.2694V3.64208H57.6307V3.00342Z",
    fill: "#75B043"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 3.00342H57.6305V3.64208H56.9963V3.00342Z",
    fill: "#75B043"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3578 3.00342H56.9965V3.64208H56.3578V3.00342Z",
    fill: "#75B043"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7188 3.64307H56.3574V4.28175H55.7188V3.64307Z",
    fill: "#75B043"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0802 4.28174H55.7189V4.9204H55.0802V4.28174Z",
    fill: "#75B043"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4458 4.91992H55.0801V5.55419H54.4458V4.91992Z",
    fill: "#75B043"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8075 5.55371H54.4462V6.19239H53.8075V5.55371Z",
    fill: "#75B043"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1683 6.19385H53.807V6.83251H53.1683V6.19385Z",
    fill: "#75B043"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M52.53 6.83203H53.1686V7.47071H52.53V6.83203Z",
    fill: "#75B043"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 7.47021H52.5303V8.10889H51.8917V7.47021Z",
    fill: "#75B043"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2572 8.1084H51.8915V8.74267H51.2572V8.1084Z",
    fill: "#75B043"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M50.618 8.74414H51.2567V9.38281H50.618V8.74414Z",
    fill: "#75B043"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6307 2.36475H58.2694V3.00342H57.6307V2.36475Z",
    fill: "#75B043"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6307 1.73145H58.2694V2.36572H57.6307V1.73145Z",
    fill: "#75B043"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 10.6592H56.3571V11.2979H55.7184V10.6592Z",
    fill: "#75B043"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 10.6592H55.7188V11.2979H55.0801V10.6592Z",
    fill: "#75B043"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4457 10.6592H55.08V11.2979H54.4457V10.6592Z",
    fill: "#75B043"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 10.021H56.3571V10.6597H55.7184V10.021Z",
    fill: "#75B043"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 10.021H55.7188V10.6597H55.0801V10.021Z",
    fill: "#75B043"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 9.38232H56.3571V10.021H55.7184V9.38232Z",
    fill: "#75B043"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 10.6592H54.446V11.2979H53.8074V10.6592Z",
    fill: "#75B043"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1682 10.6592H53.8068V11.2979H53.1682V10.6592Z",
    fill: "#75B043"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5298 10.6592H53.1685V11.2979H52.5298V10.6592Z",
    fill: "#75B043"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 10.021H54.446V10.6597H53.8074V10.021Z",
    fill: "#75B043"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1682 10.021H53.8068V10.6597H53.1682V10.021Z",
    fill: "#75B043"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 9.38232H54.446V10.021H53.8074V9.38232Z",
    fill: "#75B043"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 10.6592H52.5303V11.2979H51.8917V10.6592Z",
    fill: "#75B043"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2572 10.6592H51.8915V11.2979H51.2572V10.6592Z",
    fill: "#75B043"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M50.618 10.6592H51.2567V11.2979H50.618V10.6592Z",
    fill: "#75B043"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 10.021H52.5303V10.6597H51.8917V10.021Z",
    fill: "#75B043"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2572 10.021H51.8915V10.6597H51.2572V10.021Z",
    fill: "#75B043"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 9.38232H52.5303V10.021H51.8917V9.38232Z",
    fill: "#75B043"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 10.6592H50.6183V11.2979H49.9796V10.6592Z",
    fill: "#75B043"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3411 10.6592H49.9798V11.2979H49.3411V10.6592Z",
    fill: "#75B043"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 10.6592H49.3408V11.2979H48.7021V10.6592Z",
    fill: "#75B043"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 10.021H50.6183V10.6597H49.9796V10.021Z",
    fill: "#75B043"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 9.38232H50.6183V10.021H49.9796V9.38232Z",
    fill: "#75B043"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3406 49.3413H48.702V48.7026H49.3406V49.3413Z",
    fill: "#75B043"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9797 49.3413H49.3411V48.7026H49.9797V49.3413Z",
    fill: "#75B043"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6182 49.3413H49.9796V48.7026H50.6182V49.3413Z",
    fill: "#75B043"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 49.9756H48.702V49.3413H49.3407V49.9756Z",
    fill: "#75B043"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9797 49.9756H49.3411V49.3413H49.9797V49.9756Z",
    fill: "#75B043"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 50.6133H48.702V49.9746H49.3407V50.6133Z",
    fill: "#75B043"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 51.2515H48.702V50.6128H49.3407V51.2515Z",
    fill: "#75B043"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 51.2515H49.3411V50.6128H49.9798V51.2515Z",
    fill: "#75B043"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 51.2515H49.9796V50.6128H50.6183V51.2515Z",
    fill: "#75B043"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 51.8916H48.7021V51.2529H49.3408V51.8916Z",
    fill: "#75B043"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 51.8916H49.3411V51.2529H49.9798V51.8916Z",
    fill: "#75B043"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 52.5254H48.7021V51.8911H49.3408V52.5254Z",
    fill: "#75B043"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 53.1636H48.702V52.5249H49.3407V53.1636Z",
    fill: "#75B043"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 53.1636H49.3411V52.5249H49.9798V53.1636Z",
    fill: "#75B043"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 53.1636H49.9796V52.5249H50.6183V53.1636Z",
    fill: "#75B043"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 53.8023H48.7021V53.1636H49.3408V53.8023Z",
    fill: "#75B043"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 53.8023H49.3411V53.1636H49.9798V53.8023Z",
    fill: "#75B043"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 54.4424H48.7021V53.8037H49.3408V54.4424Z",
    fill: "#75B043"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 55.0806H48.702V54.4419H49.3407V55.0806Z",
    fill: "#75B043"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 55.0806H49.3411V54.4419H49.9798V55.0806Z",
    fill: "#75B043"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 55.0806H49.9796V54.4419H50.6183V55.0806Z",
    fill: "#75B043"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 55.7143H48.7021V55.0801H49.3408V55.7143Z",
    fill: "#75B043"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 55.7143H49.3411V55.0801H49.9798V55.7143Z",
    fill: "#75B043"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 56.3521H48.7021V55.7134H49.3408V56.3521Z",
    fill: "#75B043"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3407 56.9917H48.702V56.353H49.3407V56.9917Z",
    fill: "#75B043"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 56.9917H49.3411V56.353H49.9798V56.9917Z",
    fill: "#75B043"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6183 56.9917H49.9796V56.353H50.6183V56.9917Z",
    fill: "#75B043"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 57.6309H48.7021V56.9922H49.3408V57.6309Z",
    fill: "#75B043"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3408 58.269H48.7021V57.6304H49.3408V58.269Z",
    fill: "#75B043"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2565 49.3413H50.6179V48.7026H51.2565V49.3413Z",
    fill: "#75B043"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 49.3413H51.2572V48.7026H51.8915V49.3413Z",
    fill: "#75B043"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5303 49.3413H51.8917V48.7026H52.5303V49.3413Z",
    fill: "#75B043"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 49.9756H50.618V49.3413H51.2567V49.9756Z",
    fill: "#75B043"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 49.9756H51.2572V49.3413H51.8915V49.9756Z",
    fill: "#75B043"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 50.6133H50.618V49.9746H51.2567V50.6133Z",
    fill: "#75B043"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 49.3413H52.53V48.7026H53.1686V49.3413Z",
    fill: "#75B043"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M53.807 49.3413H53.1683V48.7026H53.807V49.3413Z",
    fill: "#75B043"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4462 49.3413H53.8075V48.7026H54.4462V49.3413Z",
    fill: "#75B043"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 49.9756H52.53V49.3413H53.1686V49.9756Z",
    fill: "#75B043"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M53.807 49.9756H53.1683V49.3413H53.807V49.9756Z",
    fill: "#75B043"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 50.6133H52.53V49.9746H53.1686V50.6133Z",
    fill: "#75B043"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5303 51.2515H51.8917V50.6128H52.5303V51.2515Z",
    fill: "#75B043"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 51.8916H51.2572V51.2529H51.8915V51.8916Z",
    fill: "#75B043"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 52.5254H50.618V51.8911H51.2567V52.5254Z",
    fill: "#75B043"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 49.3413H54.4458V48.7026H55.0801V49.3413Z",
    fill: "#75B043"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7189 49.3413H55.0802V48.7026H55.7189V49.3413Z",
    fill: "#75B043"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3574 49.3413H55.7188V48.7026H56.3574V49.3413Z",
    fill: "#75B043"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 49.9756H54.4458V49.3413H55.0801V49.9756Z",
    fill: "#75B043"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7189 49.9756H55.0802V49.3413H55.7189V49.9756Z",
    fill: "#75B043"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 50.6133H54.4458V49.9746H55.0801V50.6133Z",
    fill: "#75B043"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4462 51.2515H53.8075V50.6128H54.4462V51.2515Z",
    fill: "#75B043"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M53.807 51.8916H53.1683V51.2529H53.807V51.8916Z",
    fill: "#75B043"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1686 52.5254H52.53V51.8911H53.1686V52.5254Z",
    fill: "#75B043"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5303 53.1636H51.8917V52.5249H52.5303V53.1636Z",
    fill: "#75B043"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8915 53.8018H51.2572V53.1631H51.8915V53.8018Z",
    fill: "#75B043"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 54.4424H50.618V53.8037H51.2567V54.4424Z",
    fill: "#75B043"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 49.3413H56.3577V48.7026H56.9963V49.3413Z",
    fill: "#75B043"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6303 49.3413H56.9961V48.7026H57.6303V49.3413Z",
    fill: "#75B043"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2692 49.3413H57.6306V48.7026H58.2692V49.3413Z",
    fill: "#75B043"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 49.9756H56.3576V49.3413H56.9963V49.9756Z",
    fill: "#75B043"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 50.6133H56.3576V49.9746H56.9963V50.6133Z",
    fill: "#75B043"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 57.6304H58.2692V58.269H57.6306V57.6304Z",
    fill: "#75B043"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 57.6304H57.6303V58.269H56.9961V57.6304Z",
    fill: "#75B043"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3576 57.6304H56.9963V58.269H56.3576V57.6304Z",
    fill: "#75B043"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 56.9922H58.2692V57.6309H57.6306V56.9922Z",
    fill: "#75B043"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 56.9922H57.6303V57.6309H56.9961V56.9922Z",
    fill: "#75B043"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 56.353H58.2692V56.9917H57.6306V56.353Z",
    fill: "#75B043"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 55.7134H58.2692V56.3521H57.6306V55.7134Z",
    fill: "#75B043"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 55.7134H57.6303V56.3521H56.9961V55.7134Z",
    fill: "#75B043"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3576 55.7134H56.9963V56.3521H56.3576V55.7134Z",
    fill: "#75B043"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 55.0801H58.2692V55.7143H57.6306V55.0801Z",
    fill: "#75B043"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 55.0801H57.6303V55.7143H56.9961V55.0801Z",
    fill: "#75B043"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 54.4419H58.2692V55.0806H57.6306V54.4419Z",
    fill: "#75B043"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 53.8037H58.2691V54.4424H57.6304V53.8037Z",
    fill: "#75B043"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M56.996 53.8037H57.6302V54.4424H56.996V53.8037Z",
    fill: "#75B043"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3577 53.8037H56.9964V54.4424H56.3577V53.8037Z",
    fill: "#75B043"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 54.4419H56.3571V55.0806H55.7184V54.4419Z",
    fill: "#75B043"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 55.0801H55.7188V55.7143H55.0801V55.0801Z",
    fill: "#75B043"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4457 55.7139H55.08V56.3525H54.4457V55.7139Z",
    fill: "#75B043"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 53.1636H58.2691V53.8023H57.6304V53.1636Z",
    fill: "#75B043"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M56.996 53.1636H57.6302V53.8023H56.996V53.1636Z",
    fill: "#75B043"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 52.5249H58.2691V53.1636H57.6304V52.5249Z",
    fill: "#75B043"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 51.8911H58.2693V52.5254H57.6306V51.8911Z",
    fill: "#75B043"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9962 51.8911H57.6304V52.5254H56.9962V51.8911Z",
    fill: "#75B043"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3577 51.8911H56.9963V52.5254H56.3577V51.8911Z",
    fill: "#75B043"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7186 52.5249H56.3573V53.1636H55.7186V52.5249Z",
    fill: "#75B043"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 53.1631H55.7188V53.8018H55.0801V53.1631Z",
    fill: "#75B043"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4457 53.8032H55.0799V54.4419H54.4457V53.8032Z",
    fill: "#75B043"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 54.4419H54.446V55.0806H53.8074V54.4419Z",
    fill: "#75B043"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1682 55.0801H53.8068V55.7143H53.1682V55.0801Z",
    fill: "#75B043"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5298 55.7134H53.1685V56.3521H52.5298V55.7134Z",
    fill: "#75B043"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 51.2529H58.2693V51.8916H57.6306V51.2529Z",
    fill: "#75B043"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9962 51.2529H57.6304V51.8916H56.9962V51.2529Z",
    fill: "#75B043"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6306 50.6128H58.2693V51.2515H57.6306V50.6128Z",
    fill: "#75B043"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6307 49.9746H58.2694V50.6133H57.6307V49.9746Z",
    fill: "#75B043"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9963 49.9746H57.6305V50.6133H56.9963V49.9746Z",
    fill: "#75B043"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3578 49.9746H56.9965V50.6133H56.3578V49.9746Z",
    fill: "#75B043"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7188 50.6128H56.3574V51.2515H55.7188V50.6128Z",
    fill: "#75B043"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0802 51.2529H55.7189V51.8916H55.0802V51.2529Z",
    fill: "#75B043"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4458 51.8911H55.0801V52.5254H54.4458V51.8911Z",
    fill: "#75B043"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8075 52.5249H54.4462V53.1636H53.8075V52.5249Z",
    fill: "#75B043"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1683 53.1631H53.807V53.8018H53.1683V53.1631Z",
    fill: "#75B043"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M52.53 53.8037H53.1686V54.4424H52.53V53.8037Z",
    fill: "#75B043"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 54.4419H52.5303V55.0806H51.8917V54.4419Z",
    fill: "#75B043"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2572 55.0801H51.8915V55.7143H51.2572V55.0801Z",
    fill: "#75B043"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M50.618 55.7134H51.2567V56.3521H50.618V55.7134Z",
    fill: "#75B043"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6307 49.3413H58.2694V49.9756H57.6307V49.3413Z",
    fill: "#75B043"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6307 48.7026H58.2694V49.3413H57.6307V48.7026Z",
    fill: "#75B043"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 57.6304H56.3571V58.269H55.7184V57.6304Z",
    fill: "#75B043"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 57.6304H55.7188V58.269H55.0801V57.6304Z",
    fill: "#75B043"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4457 57.6304H55.08V58.269H54.4457V57.6304Z",
    fill: "#75B043"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 56.9922H56.3571V57.6309H55.7184V56.9922Z",
    fill: "#75B043"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0801 56.9922H55.7188V57.6309H55.0801V56.9922Z",
    fill: "#75B043"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 56.353H56.3571V56.9917H55.7184V56.353Z",
    fill: "#75B043"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 57.6304H54.446V58.269H53.8074V57.6304Z",
    fill: "#75B043"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1682 57.6304H53.8068V58.269H53.1682V57.6304Z",
    fill: "#75B043"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5298 57.6304H53.1685V58.269H52.5298V57.6304Z",
    fill: "#75B043"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 56.9922H54.446V57.6309H53.8074V56.9922Z",
    fill: "#75B043"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1682 56.9922H53.8068V57.6309H53.1682V56.9922Z",
    fill: "#75B043"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8074 56.353H54.446V56.9917H53.8074V56.353Z",
    fill: "#75B043"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 57.6304H52.5303V58.269H51.8917V57.6304Z",
    fill: "#75B043"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2572 57.6304H51.8915V58.269H51.2572V57.6304Z",
    fill: "#75B043"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M50.618 57.6304H51.2567V58.269H50.618V57.6304Z",
    fill: "#75B043"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 56.9922H52.5303V57.6309H51.8917V56.9922Z",
    fill: "#75B043"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2572 56.9922H51.8915V57.6309H51.2572V56.9922Z",
    fill: "#75B043"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 56.353H52.5303V56.9917H51.8917V56.353Z",
    fill: "#75B043"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 57.6304H50.6183V58.269H49.9796V57.6304Z",
    fill: "#75B043"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3411 57.6304H49.9798V58.269H49.3411V57.6304Z",
    fill: "#75B043"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 57.6304H49.3408V58.269H48.7021V57.6304Z",
    fill: "#75B043"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 56.9922H50.6183V57.6309H49.9796V56.9922Z",
    fill: "#75B043"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 56.353H50.6183V56.9917H49.9796V56.353Z",
    fill: "#75B043"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36982 2.36572H1.73114V1.73145H2.36982V2.36572Z",
    fill: "#75B043"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00805 2.36572H2.36938V1.73145H3.00805V2.36572Z",
    fill: "#75B043"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64728 2.36572H3.00861V1.73145H3.64728V2.36572Z",
    fill: "#75B043"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 3.00342H1.73108V2.36475H2.36976V3.00342Z",
    fill: "#75B043"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00805 3.00342H2.36938V2.36475H3.00805V3.00342Z",
    fill: "#75B043"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 3.64208H1.73108V3.00342H2.36976V3.64208Z",
    fill: "#75B043"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 4.28175H1.73108V3.64307H2.36976V4.28175Z",
    fill: "#75B043"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 4.28175H2.36932V3.64307H3.00799V4.28175Z",
    fill: "#75B043"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 4.28175H3.00854V3.64307H3.64722V4.28175Z",
    fill: "#75B043"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 4.9204H1.73102V4.28174H2.3697V4.9204Z",
    fill: "#75B043"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 4.9204H2.36932V4.28174H3.00799V4.9204Z",
    fill: "#75B043"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 5.55419H1.73102V4.91992H2.3697V5.55419Z",
    fill: "#75B043"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 6.19239H1.73108V5.55371H2.36976V6.19239Z",
    fill: "#75B043"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 6.19239H2.36932V5.55371H3.00799V6.19239Z",
    fill: "#75B043"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 6.19239H3.00854V5.55371H3.64722V6.19239Z",
    fill: "#75B043"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 6.83251H1.73102V6.19385H2.3697V6.83251Z",
    fill: "#75B043"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 6.83251H2.36932V6.19385H3.00799V6.83251Z",
    fill: "#75B043"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 7.47071H1.73102V6.83203H2.3697V7.47071Z",
    fill: "#75B043"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 8.10889H1.73108V7.47021H2.36976V8.10889Z",
    fill: "#75B043"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 8.10889H2.36932V7.47021H3.00799V8.10889Z",
    fill: "#75B043"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 8.10889H3.00854V7.47021H3.64722V8.10889Z",
    fill: "#75B043"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 8.74267H1.73102V8.1084H2.3697V8.74267Z",
    fill: "#75B043"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 8.74267H2.36932V8.1084H3.00799V8.74267Z",
    fill: "#75B043"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 9.38281H1.73102V8.74414H2.3697V9.38281Z",
    fill: "#75B043"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 10.021H1.73108V9.38232H2.36976V10.021Z",
    fill: "#75B043"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 10.021H2.36932V9.38232H3.00799V10.021Z",
    fill: "#75B043"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 10.021H3.00854V9.38232H3.64722V10.021Z",
    fill: "#75B043"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 10.6597H1.73102V10.021H2.3697V10.6597Z",
    fill: "#75B043"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 11.2979H1.73102V10.6592H2.3697V11.2979Z",
    fill: "#75B043"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 2.36572H3.64691V1.73145H4.28118V2.36572Z",
    fill: "#75B043"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 2.36572H4.28137V1.73145H4.92004V2.36572Z",
    fill: "#75B043"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5586 2.36572H4.91992V1.73145H5.5586V2.36572Z",
    fill: "#75B043"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 3.00342H3.64691V2.36475H4.28118V3.00342Z",
    fill: "#75B043"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 3.00342H4.28137V2.36475H4.92004V3.00342Z",
    fill: "#75B043"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 3.64208H3.64691V3.00342H4.28118V3.64208Z",
    fill: "#75B043"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 2.36572H5.5589V1.73145H6.19758V2.36572Z",
    fill: "#75B043"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83587 2.36572H6.1972V1.73145H6.83587V2.36572Z",
    fill: "#75B043"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46996 2.36572H6.83569V1.73145H7.46996V2.36572Z",
    fill: "#75B043"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 3.00342H5.5589V2.36475H6.19758V3.00342Z",
    fill: "#75B043"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83587 3.00342H6.1972V2.36475H6.83587V3.00342Z",
    fill: "#75B043"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 3.64208H5.5589V3.00342H6.19758V3.64208Z",
    fill: "#75B043"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5586 4.28175H4.91992V3.64307H5.5586V4.28175Z",
    fill: "#75B043"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 4.9204H4.28137V4.28174H4.92004V4.9204Z",
    fill: "#75B043"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 5.55419H3.64691V4.91992H4.28118V5.55419Z",
    fill: "#75B043"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10883 2.36572H7.47015V1.73145H8.10883V2.36572Z",
    fill: "#75B043"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74712 2.36572H8.10846V1.73145H8.74712V2.36572Z",
    fill: "#75B043"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38636 2.36572H8.74768V1.73145H9.38636V2.36572Z",
    fill: "#75B043"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10883 3.00342H7.47015V2.36475H8.10883V3.00342Z",
    fill: "#75B043"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74712 3.00342H8.10846V2.36475H8.74712V3.00342Z",
    fill: "#75B043"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10883 3.64208H7.47015V3.00342H8.10883V3.64208Z",
    fill: "#75B043"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46996 4.28175H6.83569V3.64307H7.46996V4.28175Z",
    fill: "#75B043"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83587 4.9204H6.1972V4.28174H6.83587V4.9204Z",
    fill: "#75B043"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 5.55419H5.5589V4.91992H6.19758V5.55419Z",
    fill: "#75B043"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5586 6.19239H4.91992V5.55371H5.5586V6.19239Z",
    fill: "#75B043"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 6.83251H4.28137V6.19385H4.92004V6.83251Z",
    fill: "#75B043"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 7.47071H3.64691V6.83203H4.28118V7.47071Z",
    fill: "#75B043"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 2.36572H9.38599V1.73145H10.0247V2.36572Z",
    fill: "#75B043"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6595 2.36572H10.0253V1.73145H10.6595V2.36572Z",
    fill: "#75B043"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2977 2.36572H10.659V1.73145H11.2977V2.36572Z",
    fill: "#75B043"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 3.00342H9.38605V2.36475H10.0247V3.00342Z",
    fill: "#75B043"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 3.64208H9.38605V3.00342H10.0247V3.64208Z",
    fill: "#75B043"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 10.6592H11.2977V11.2979H10.659V10.6592Z",
    fill: "#75B043"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 10.6592H10.6595V11.2979H10.0253V10.6592Z",
    fill: "#75B043"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38605 10.6592H10.0247V11.2979H9.38605V10.6592Z",
    fill: "#75B043"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 10.021H11.2977V10.6597H10.659V10.021Z",
    fill: "#75B043"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 10.021H10.6595V10.6597H10.0253V10.021Z",
    fill: "#75B043"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 9.38232H11.2977V10.021H10.659V9.38232Z",
    fill: "#75B043"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 8.74414H11.2977V9.38281H10.659V8.74414Z",
    fill: "#75B043"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 8.74414H10.6595V9.38281H10.0253V8.74414Z",
    fill: "#75B043"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38605 8.74414H10.0247V9.38281H9.38605V8.74414Z",
    fill: "#75B043"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 8.1084H11.2977V8.74267H10.659V8.1084Z",
    fill: "#75B043"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 8.1084H10.6595V8.74267H10.0253V8.1084Z",
    fill: "#75B043"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 7.47021H11.2977V8.10889H10.659V7.47021Z",
    fill: "#75B043"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 6.83203H11.2976V7.47071H10.6589V6.83203Z",
    fill: "#75B043"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0252 6.83203H10.6595V7.47071H10.0252V6.83203Z",
    fill: "#75B043"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38599 6.83203H10.0247V7.47071H9.38599V6.83203Z",
    fill: "#75B043"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 7.47021H9.38636V8.10889H8.74768V7.47021Z",
    fill: "#75B043"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 8.1084H8.74712V8.74267H8.10846V8.1084Z",
    fill: "#75B043"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47015 8.74414H8.10883V9.38281H7.47015V8.74414Z",
    fill: "#75B043"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 6.19385H11.2976V6.83251H10.6589V6.19385Z",
    fill: "#75B043"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0252 6.19385H10.6595V6.83251H10.0252V6.19385Z",
    fill: "#75B043"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 5.55371H11.2976V6.19239H10.6589V5.55371Z",
    fill: "#75B043"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6588 4.91992H11.2975V5.55419H10.6588V4.91992Z",
    fill: "#75B043"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0251 4.91992H10.6594V5.55419H10.0251V4.91992Z",
    fill: "#75B043"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38586 4.91992H10.0245V5.55419H9.38586V4.91992Z",
    fill: "#75B043"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74756 5.55322H9.38624V6.1919H8.74756V5.55322Z",
    fill: "#75B043"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10834 6.19385H8.747V6.83251H8.10834V6.19385Z",
    fill: "#75B043"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47003 6.83203H8.10871V7.47071H7.47003V6.83203Z",
    fill: "#75B043"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 7.47021H7.46984V8.10889H6.83557V7.47021Z",
    fill: "#75B043"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 8.1084H6.83575V8.74267H6.19708V8.1084Z",
    fill: "#75B043"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55878 8.74414H6.19746V9.38281H5.55878V8.74414Z",
    fill: "#75B043"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6588 4.28174H11.2975V4.9204H10.6588V4.28174Z",
    fill: "#75B043"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0251 4.28174H10.6594V4.9204H10.0251V4.28174Z",
    fill: "#75B043"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6588 3.64307H11.2975V4.28175H10.6588V3.64307Z",
    fill: "#75B043"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 3.00342H11.2976V3.64208H10.6589V3.00342Z",
    fill: "#75B043"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0252 3.00342H10.6595V3.64208H10.0252V3.00342Z",
    fill: "#75B043"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38599 3.00342H10.0247V3.64208H9.38599V3.00342Z",
    fill: "#75B043"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 3.64307H9.38636V4.28175H8.74768V3.64307Z",
    fill: "#75B043"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 4.28174H8.74712V4.9204H8.10846V4.28174Z",
    fill: "#75B043"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47015 4.91992H8.10883V5.55419H7.47015V4.91992Z",
    fill: "#75B043"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83569 5.55371H7.46996V6.19239H6.83569V5.55371Z",
    fill: "#75B043"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1972 6.19385H6.83587V6.83251H6.1972V6.19385Z",
    fill: "#75B043"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5589 6.83203H6.19758V7.47071H5.5589V6.83203Z",
    fill: "#75B043"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 7.47021H5.5586V8.10889H4.91992V7.47021Z",
    fill: "#75B043"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28137 8.1084H4.92004V8.74267H4.28137V8.1084Z",
    fill: "#75B043"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64691 8.74414H4.28118V9.38281H3.64691V8.74414Z",
    fill: "#75B043"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 2.36475H11.2976V3.00342H10.6589V2.36475Z",
    fill: "#75B043"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 1.73145H11.2976V2.36572H10.6589V1.73145Z",
    fill: "#75B043"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 10.6592H9.38636V11.2979H8.74768V10.6592Z",
    fill: "#75B043"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 10.6592H8.74712V11.2979H8.10846V10.6592Z",
    fill: "#75B043"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47015 10.6592H8.10883V11.2979H7.47015V10.6592Z",
    fill: "#75B043"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 10.021H9.38636V10.6597H8.74768V10.021Z",
    fill: "#75B043"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 10.021H8.74712V10.6597H8.10846V10.021Z",
    fill: "#75B043"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 9.38232H9.38636V10.021H8.74768V9.38232Z",
    fill: "#75B043"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 10.6592H7.46984V11.2979H6.83557V10.6592Z",
    fill: "#75B043"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 10.6592H6.83575V11.2979H6.19708V10.6592Z",
    fill: "#75B043"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55878 10.6592H6.19746V11.2979H5.55878V10.6592Z",
    fill: "#75B043"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 10.021H7.46984V10.6597H6.83557V10.021Z",
    fill: "#75B043"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 10.021H6.83575V10.6597H6.19708V10.021Z",
    fill: "#75B043"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 9.38232H7.46984V10.021H6.83557V9.38232Z",
    fill: "#75B043"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 10.6592H5.5586V11.2979H4.91992V10.6592Z",
    fill: "#75B043"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28137 10.6592H4.92004V11.2979H4.28137V10.6592Z",
    fill: "#75B043"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64691 10.6592H4.28118V11.2979H3.64691V10.6592Z",
    fill: "#75B043"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 10.021H5.5586V10.6597H4.91992V10.021Z",
    fill: "#75B043"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28137 10.021H4.92004V10.6597H4.28137V10.021Z",
    fill: "#75B043"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 9.38232H5.5586V10.021H4.91992V9.38232Z",
    fill: "#75B043"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00854 10.6592H3.64722V11.2979H3.00854V10.6592Z",
    fill: "#75B043"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36932 10.6592H3.00799V11.2979H2.36932V10.6592Z",
    fill: "#75B043"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 10.6592H2.3697V11.2979H1.73102V10.6592Z",
    fill: "#75B043"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00854 10.021H3.64722V10.6597H3.00854V10.021Z",
    fill: "#75B043"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00854 9.38232H3.64722V10.021H3.00854V9.38232Z",
    fill: "#75B043"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36982 49.3413H1.73114V48.7026H2.36982V49.3413Z",
    fill: "#75B043"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00805 49.3413H2.36938V48.7026H3.00805V49.3413Z",
    fill: "#75B043"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64728 49.3413H3.00861V48.7026H3.64728V49.3413Z",
    fill: "#75B043"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 49.9756H1.73108V49.3413H2.36976V49.9756Z",
    fill: "#75B043"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00805 49.9756H2.36938V49.3413H3.00805V49.9756Z",
    fill: "#75B043"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 50.6133H1.73108V49.9746H2.36976V50.6133Z",
    fill: "#75B043"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 51.2515H1.73108V50.6128H2.36976V51.2515Z",
    fill: "#75B043"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 51.2515H2.36932V50.6128H3.00799V51.2515Z",
    fill: "#75B043"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 51.2515H3.00854V50.6128H3.64722V51.2515Z",
    fill: "#75B043"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 51.8916H1.73102V51.2529H2.3697V51.8916Z",
    fill: "#75B043"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 51.8916H2.36932V51.2529H3.00799V51.8916Z",
    fill: "#75B043"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 52.5254H1.73102V51.8911H2.3697V52.5254Z",
    fill: "#75B043"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 53.1636H1.73108V52.5249H2.36976V53.1636Z",
    fill: "#75B043"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 53.1636H2.36932V52.5249H3.00799V53.1636Z",
    fill: "#75B043"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 53.1636H3.00854V52.5249H3.64722V53.1636Z",
    fill: "#75B043"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 53.8023H1.73102V53.1636H2.3697V53.8023Z",
    fill: "#75B043"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 53.8023H2.36932V53.1636H3.00799V53.8023Z",
    fill: "#75B043"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 54.4424H1.73102V53.8037H2.3697V54.4424Z",
    fill: "#75B043"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 55.0806H1.73108V54.4419H2.36976V55.0806Z",
    fill: "#75B043"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 55.0806H2.36932V54.4419H3.00799V55.0806Z",
    fill: "#75B043"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 55.0806H3.00854V54.4419H3.64722V55.0806Z",
    fill: "#75B043"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 55.7143H1.73102V55.0801H2.3697V55.7143Z",
    fill: "#75B043"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 55.7143H2.36932V55.0801H3.00799V55.7143Z",
    fill: "#75B043"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 56.3521H1.73102V55.7134H2.3697V56.3521Z",
    fill: "#75B043"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36976 56.9917H1.73108V56.353H2.36976V56.9917Z",
    fill: "#75B043"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00799 56.9917H2.36932V56.353H3.00799V56.9917Z",
    fill: "#75B043"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64722 56.9917H3.00854V56.353H3.64722V56.9917Z",
    fill: "#75B043"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 57.6309H1.73102V56.9922H2.3697V57.6309Z",
    fill: "#75B043"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3697 58.269H1.73102V57.6304H2.3697V58.269Z",
    fill: "#75B043"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 49.3413H3.64691V48.7026H4.28118V49.3413Z",
    fill: "#75B043"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 49.3413H4.28137V48.7026H4.92004V49.3413Z",
    fill: "#75B043"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5586 49.3413H4.91992V48.7026H5.5586V49.3413Z",
    fill: "#75B043"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 49.9756H3.64691V49.3413H4.28118V49.9756Z",
    fill: "#75B043"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 49.9756H4.28137V49.3413H4.92004V49.9756Z",
    fill: "#75B043"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 50.6133H3.64691V49.9746H4.28118V50.6133Z",
    fill: "#75B043"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 49.3413H5.5589V48.7026H6.19758V49.3413Z",
    fill: "#75B043"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83587 49.3413H6.1972V48.7026H6.83587V49.3413Z",
    fill: "#75B043"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46996 49.3413H6.83569V48.7026H7.46996V49.3413Z",
    fill: "#75B043"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 49.9756H5.5589V49.3413H6.19758V49.9756Z",
    fill: "#75B043"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83587 49.9756H6.1972V49.3413H6.83587V49.9756Z",
    fill: "#75B043"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 50.6133H5.5589V49.9746H6.19758V50.6133Z",
    fill: "#75B043"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5586 51.2515H4.91992V50.6128H5.5586V51.2515Z",
    fill: "#75B043"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 51.8916H4.28137V51.2529H4.92004V51.8916Z",
    fill: "#75B043"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 52.5254H3.64691V51.8911H4.28118V52.5254Z",
    fill: "#75B043"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10883 49.3413H7.47015V48.7026H8.10883V49.3413Z",
    fill: "#75B043"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74712 49.3413H8.10846V48.7026H8.74712V49.3413Z",
    fill: "#75B043"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38636 49.3413H8.74768V48.7026H9.38636V49.3413Z",
    fill: "#75B043"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10883 49.9756H7.47015V49.3413H8.10883V49.9756Z",
    fill: "#75B043"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74712 49.9756H8.10846V49.3413H8.74712V49.9756Z",
    fill: "#75B043"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10883 50.6133H7.47015V49.9746H8.10883V50.6133Z",
    fill: "#75B043"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46996 51.2515H6.83569V50.6128H7.46996V51.2515Z",
    fill: "#75B043"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83587 51.8916H6.1972V51.2529H6.83587V51.8916Z",
    fill: "#75B043"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19758 52.5254H5.5589V51.8911H6.19758V52.5254Z",
    fill: "#75B043"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5586 53.1636H4.91992V52.5249H5.5586V53.1636Z",
    fill: "#75B043"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 53.8018H4.28137V53.1631H4.92004V53.8018Z",
    fill: "#75B043"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28118 54.4424H3.64691V53.8037H4.28118V54.4424Z",
    fill: "#75B043"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 49.3413H9.38599V48.7026H10.0247V49.3413Z",
    fill: "#75B043"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6595 49.3413H10.0253V48.7026H10.6595V49.3413Z",
    fill: "#75B043"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2977 49.3413H10.659V48.7026H11.2977V49.3413Z",
    fill: "#75B043"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 49.9756H9.38605V49.3413H10.0247V49.9756Z",
    fill: "#75B043"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0247 50.6133H9.38605V49.9746H10.0247V50.6133Z",
    fill: "#75B043"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 57.6304H11.2977V58.269H10.659V57.6304Z",
    fill: "#75B043"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 57.6304H10.6595V58.269H10.0253V57.6304Z",
    fill: "#75B043"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38605 57.6304H10.0247V58.269H9.38605V57.6304Z",
    fill: "#75B043"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 56.9922H11.2977V57.6309H10.659V56.9922Z",
    fill: "#75B043"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 56.9922H10.6595V57.6309H10.0253V56.9922Z",
    fill: "#75B043"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 56.353H11.2977V56.9917H10.659V56.353Z",
    fill: "#75B043"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 55.7134H11.2977V56.3521H10.659V55.7134Z",
    fill: "#75B043"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 55.7134H10.6595V56.3521H10.0253V55.7134Z",
    fill: "#75B043"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38605 55.7134H10.0247V56.3521H9.38605V55.7134Z",
    fill: "#75B043"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 55.0801H11.2977V55.7143H10.659V55.0801Z",
    fill: "#75B043"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0253 55.0801H10.6595V55.7143H10.0253V55.0801Z",
    fill: "#75B043"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 54.4419H11.2977V55.0806H10.659V54.4419Z",
    fill: "#75B043"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 53.8037H11.2976V54.4424H10.6589V53.8037Z",
    fill: "#75B043"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0252 53.8037H10.6595V54.4424H10.0252V53.8037Z",
    fill: "#75B043"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38599 53.8037H10.0247V54.4424H9.38599V53.8037Z",
    fill: "#75B043"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 54.4419H9.38636V55.0806H8.74768V54.4419Z",
    fill: "#75B043"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 55.0801H8.74712V55.7143H8.10846V55.0801Z",
    fill: "#75B043"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47015 55.7139H8.10883V56.3525H7.47015V55.7139Z",
    fill: "#75B043"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 53.1636H11.2976V53.8023H10.6589V53.1636Z",
    fill: "#75B043"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0252 53.1636H10.6595V53.8023H10.0252V53.1636Z",
    fill: "#75B043"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 52.5249H11.2976V53.1636H10.6589V52.5249Z",
    fill: "#75B043"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6588 51.8911H11.2975V52.5254H10.6588V51.8911Z",
    fill: "#75B043"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0251 51.8911H10.6594V52.5254H10.0251V51.8911Z",
    fill: "#75B043"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38586 51.8911H10.0245V52.5254H9.38586V51.8911Z",
    fill: "#75B043"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74756 52.5249H9.38624V53.1636H8.74756V52.5249Z",
    fill: "#75B043"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10834 53.1631H8.747V53.8018H8.10834V53.1631Z",
    fill: "#75B043"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47003 53.8032H8.10871V54.4419H7.47003V53.8032Z",
    fill: "#75B043"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 54.4419H7.46984V55.0806H6.83557V54.4419Z",
    fill: "#75B043"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 55.0801H6.83575V55.7143H6.19708V55.0801Z",
    fill: "#75B043"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55878 55.7134H6.19746V56.3521H5.55878V55.7134Z",
    fill: "#75B043"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6588 51.2529H11.2975V51.8916H10.6588V51.2529Z",
    fill: "#75B043"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0251 51.2529H10.6594V51.8916H10.0251V51.2529Z",
    fill: "#75B043"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6588 50.6128H11.2975V51.2515H10.6588V50.6128Z",
    fill: "#75B043"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 49.9746H11.2976V50.6133H10.6589V49.9746Z",
    fill: "#75B043"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0252 49.9746H10.6595V50.6133H10.0252V49.9746Z",
    fill: "#75B043"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38599 49.9746H10.0247V50.6133H9.38599V49.9746Z",
    fill: "#75B043"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 50.6128H9.38636V51.2515H8.74768V50.6128Z",
    fill: "#75B043"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 51.2529H8.74712V51.8916H8.10846V51.2529Z",
    fill: "#75B043"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47015 51.8911H8.10883V52.5254H7.47015V51.8911Z",
    fill: "#75B043"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83569 52.5249H7.46996V53.1636H6.83569V52.5249Z",
    fill: "#75B043"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1972 53.1631H6.83587V53.8018H6.1972V53.1631Z",
    fill: "#75B043"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5589 53.8037H6.19758V54.4424H5.5589V53.8037Z",
    fill: "#75B043"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 54.4419H5.5586V55.0806H4.91992V54.4419Z",
    fill: "#75B043"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28137 55.0801H4.92004V55.7143H4.28137V55.0801Z",
    fill: "#75B043"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64691 55.7134H4.28118V56.3521H3.64691V55.7134Z",
    fill: "#75B043"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 49.3413H11.2976V49.9756H10.6589V49.3413Z",
    fill: "#75B043"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6589 48.7026H11.2976V49.3413H10.6589V48.7026Z",
    fill: "#75B043"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 57.6304H9.38636V58.269H8.74768V57.6304Z",
    fill: "#75B043"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 57.6304H8.74712V58.269H8.10846V57.6304Z",
    fill: "#75B043"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47015 57.6304H8.10883V58.269H7.47015V57.6304Z",
    fill: "#75B043"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 56.9922H9.38636V57.6309H8.74768V56.9922Z",
    fill: "#75B043"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10846 56.9922H8.74712V57.6309H8.10846V56.9922Z",
    fill: "#75B043"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74768 56.353H9.38636V56.9917H8.74768V56.353Z",
    fill: "#75B043"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 57.6304H7.46984V58.269H6.83557V57.6304Z",
    fill: "#75B043"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 57.6304H6.83575V58.269H6.19708V57.6304Z",
    fill: "#75B043"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55878 57.6304H6.19746V58.269H5.55878V57.6304Z",
    fill: "#75B043"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 56.9922H7.46984V57.6309H6.83557V56.9922Z",
    fill: "#75B043"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 56.9922H6.83575V57.6309H6.19708V56.9922Z",
    fill: "#75B043"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83557 56.353H7.46984V56.9917H6.83557V56.353Z",
    fill: "#75B043"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 57.6304H5.5586V58.269H4.91992V57.6304Z",
    fill: "#75B043"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28137 57.6304H4.92004V58.269H4.28137V57.6304Z",
    fill: "#75B043"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64691 57.6304H4.28118V58.269H3.64691V57.6304Z",
    fill: "#75B043"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 56.9922H5.5586V57.6309H4.91992V56.9922Z",
    fill: "#75B043"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28137 56.9922H4.92004V57.6309H4.28137V56.9922Z",
    fill: "#75B043"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91992 56.353H5.5586V56.9917H4.91992V56.353Z",
    fill: "#75B043"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00854 57.6304H3.64722V58.269H3.00854V57.6304Z",
    fill: "#75B043"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36932 57.6304H3.00799V58.269H2.36932V57.6304Z",
    fill: "#75B043"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73102 57.6304H2.3697V58.269H1.73102V57.6304Z",
    fill: "#75B043"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00854 56.9922H3.64722V57.6309H3.00854V56.9922Z",
    fill: "#75B043"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00854 56.353H3.64722V56.9917H3.00854V56.353Z",
    fill: "#75B043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalLogo);
export default __webpack_public_path__ + "static/media/national-logo.157626e1ff59e01a1ea31fc4a448bc83.svg";
export { ForwardRef as ReactComponent };